import { networkService } from "services/networkService";
import {
  METHOD_SRA_LIST,
  METHOD_SRA_CREATE,
  METHOD_SRA_UPDATE,
  METHOD_SRA_DELETE,
  METHOD_SRA_DETAIL,
} from "constants/admin/masters/sra";
class SraService {
  getAll = (data) => {
    return networkService
      .post(METHOD_SRA_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_SRA_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_SRA_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_SRA_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_SRA_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default SraService;
